import { render, staticRenderFns } from "./exchange-bulk-item-gift.vue?vue&type=template&id=cdb8a7a0&"
import script from "./exchange-bulk-item-gift.vue?vue&type=script&lang=js&"
export * from "./exchange-bulk-item-gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports